import React, { useState, useEffect } from 'react'
import Text from '@amzn/meridian/text'
import Row from '@amzn/meridian/row'
import Button from '@amzn/meridian/button'
import Modal, { ModalFooter } from '@amzn/meridian/modal'
import { globalEventBus } from '@amzn/ihm-associate-tools-js-lib'
import { AssociateToolsBaseEventBusTopics } from '@utils/Constants/AssociateToolsBaseEventBusTopics'

let subscriptionHandle
let title
let content
let secondaryButtonText
let primaryButtonText
let primaryButtonCallback: Function
let secondaryButtonCallback: Function

const NotificationModal = (): React.ReactElement => {

    const [open, setOpen] = useState(false)

    const show = (request) => {
        console.log('ATBase: NotificationModal show request: ',request)
        title = request.data.title ? request.data.title : 'title'
        content = request.data.content ? request.data.content : 'content'
        secondaryButtonText = request.data.secondaryButtonText ? request.data.secondaryButtonText : 'secondaryButtonText'
        primaryButtonText = request.data.primaryButtonText ? request.data.primaryButtonText : 'primaryButtonText'
        primaryButtonCallback = request.data.primaryButtonCallback ? request.data.primaryButtonCallback : () => {}
        secondaryButtonCallback = request.data.secondaryButtonCallback ? request.data.secondaryButtonCallback : () => {}
        setOpen(true)
    }

    /**
     * Initialization function. Subscribes show() into global event bus.
     */
    const activate = () => {
        console.log('ATBase: NotificationModal activate')
        subscriptionHandle = globalEventBus.on(AssociateToolsBaseEventBusTopics.SHOW_NOTIFICATION_MODAL, 'notification', show)
    }

    /**
     * Cleans up global event bus subscription.
     */
    const onDestroy = () => {
        subscriptionHandle.off()
    }

    useEffect(() => {
        activate()

        // returned function will be called on component unmount
        return () => {
            onDestroy()
        }
    }, [])

    return (
        <Modal
            title = {title}
            aria-describedby="modal-description"
            open={open}
            width="90vw"
        >
            <Text id="modal-description">{content}</Text>
            <ModalFooter>
                <Row alignmentHorizontal="end" widths="fit">
                    <Button
                        type="secondary"
                        size="large"
                        onClick={() => {
                            secondaryButtonCallback()
                            setOpen(false)
                        }}
                    >
                        {secondaryButtonText}
                    </Button>
                    <Button
                        type="primary"
                        size="large"
                        onClick={() => {
                            primaryButtonCallback()
                            setOpen(false)
                        }}
                    >
                    {primaryButtonText}
                    </Button>
                </Row>
            </ModalFooter>
        </Modal>
    )
}

export default NotificationModal
